import Link from 'next/link'
import { Disclosure } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { classNames } from 'common/utils'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { PATHS, topNavLinks } from '@/common/const'
import Image from 'next/image'
import { NavCheckInStatus } from './DisplayCheckIn'

export function TopNav() {
  const router = useRouter()
  const navigation = useMemo(
    () =>
      topNavLinks.map((link) => {
        return {
          ...link,
          current: router.asPath.indexOf(link.href) == 0,
        }
      }),
    [router?.asPath]
  )

  return (
    <Disclosure as="nav" className="bg-gray-800 dark:bg-gray-900 border-b dark:border-gray-500">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-4xl px-4 sm:px-2 lg:px-6">
            <div className="flex h-12 items-center justify-between">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Link href={PATHS.HOME}>
                    <Image className="h-6 w-6" src="/icon.svg" width={20} height={20} alt="Backup Diary logo" />
                  </Link>
                </div>
                <div className="hidden md:block">
                  <div className="ml-10 flex items-baseline space-x-4">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? 'text-white border-b '
                            : 'text-gray-300 hover:border-dashed hover:border-b hover:text-white',
                          'text-sm font-medium'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <NavCheckInStatus />
                <div className="-mr-2 flex md:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="md:hidden">
            <div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? 'bg-gray-900 text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                    'block px-3 py-2 rounded-md text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
            {/* Divider on mobile. In case needed
            <div className="border-t border-gray-700 pt-4 pb-3">
            </div> */}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
